module.exports = __webpack_public_path__ + "img/quality@2x.76d8445.png";